import Actions from 'actions'
import AddToNotes from 'components/common/icons/timelineV2/scan-feed/AddToNotes'
import SendSelectedImages from 'components/common/icons/timelineV2/scan-feed/SendSelectedImages'
import useFeatureFlags from 'hooks/useFeatureFlags'
import useSendChatMessage from 'hooks/useSendChatMessage'
import { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import useAddAttachmentsToNote from './useAddAttachmentsToNote'
import { v4 } from 'uuid'

export default ({ scanId }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const [isSendInChatCooldownActive, setIsSendInChatCooldownActive] = useState(false)
  const [isAddingToNote, setIsAddingToNote] = useState(false)

  const { sendMessage } = useSendChatMessage()
  const { addAttachmentsToNote: addAttachmentsToNoteFF } = useFeatureFlags()
  const { handleAddAttachmentsToNote } = useAddAttachmentsToNote()

  const handleSendInChat = useCallback(
    imageBase64 => {
      sendMessage({
        type: 'image',
        content: Buffer.from(imageBase64.replace(/^data:image\/\w+;base64,/, ''), 'base64'),
        cache: imageBase64
      })

      // Displaying a snackbar and disabling the button for as a better indication that the image was sent

      dispatch(
        Actions.showSnackbar({
          type: 'success',
          text: t('messages.chat.imageSentSuccessfully')
        })
      )

      setIsSendInChatCooldownActive(true)
      setTimeout(() => setIsSendInChatCooldownActive(false), 2000)
    },
    [sendMessage, t, dispatch]
  )

  const handleAddImageToNote = useCallback(
    async imageBase64 => {
      setIsAddingToNote(true)
      await handleAddAttachmentsToNote({
        attachments: [
          {
            type: 'image',
            contentType: 'image/png',
            data: Buffer.from(imageBase64.replace(/^data:image\/\w+;base64,/, ''), 'base64'),
            key: `scan-summary-image-${v4()}.png`
          }
        ]
      })
      setIsAddingToNote(false)
    },
    [handleAddAttachmentsToNote]
  )

  const customActions = useMemo(
    () =>
      [
        {
          icon: <SendSelectedImages color="var(--text-color-3)" />,
          label: t('pages.patients.selectedPatient.timelineV2.scanFeed.sendInChat'),
          disabled: isSendInChatCooldownActive,
          onClick: handleSendInChat,
          condition: () => true
        },
        {
          icon: <AddToNotes color="var(--text-color-3)" />,
          label: t('pages.patients.selectedPatient.timelineV2.scanFeed.addToNotes'),
          disabled: isAddingToNote,
          isLoading: isAddingToNote,
          onClick: handleAddImageToNote,
          condition: () => addAttachmentsToNoteFF
        }
      ].filter(action => action.condition()),
    [t, isSendInChatCooldownActive, handleSendInChat, isAddingToNote, handleAddImageToNote, addAttachmentsToNoteFF]
  )

  return customActions
}
